import "./BottomToTop.css";

export const BottomToTop = () => {
  return (
    <>
      <a href='#top'>
        <div className=' btn-top badge-av'>
          <div className='avatar avatar-top av-pink'>
            <i className='fas fa-lg  fa-arrow-up'></i>
          </div>
        </div>
      </a>
    </>
  );
};
